import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.6.0_3be17c5ec8c5a2410f443b077286cf75/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}